import React, { useEffect, useMemo } from "react";
import { Panel, Text, Title, Field } from "components/commons";
import lang from "translations";
import classNames from "classnames";
import style from "./booking-summary.module.scss";
import { formatDate } from "services";
import { DateTime } from "enums";

const BookingSummary = ({ data: bookingDetailsData, externalTicketId }) => {

  const labelText = (label = "", text) => (
    <Field label={label}>
      <Text>{text ?? "-"}</Text>
    </Field>
  );

  useEffect(() => {
    console.log("bookingDetailsData", bookingDetailsData);
    console.log("externalTicketId", externalTicketId);
  }, [bookingDetailsData, externalTicketId]);

  // find matching guest by externalTicketId
  const matchedGuest = useMemo(() => {
    if (!bookingDetailsData?.bookingCustomers || !externalTicketId) return null;
    return bookingDetailsData.bookingCustomers.find(
      (cust) => cust.externalTicketId.toLowerCase() === externalTicketId.toLowerCase()
    );
  }, [bookingDetailsData, externalTicketId]);

  const guestInfo = matchedGuest?.customer;

  return (
    <div className="grid grid-cols-12 gap-x-4">
      <Panel
        className={classNames("col-span-12 md:col-span-12", style.panelHeight)}
      >
        <Title className="mb-lg">{lang.bookingDetails}</Title>

        {/* 🔹 Booking-level info */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          {labelText(lang.ticketNo, matchedGuest?.externalTicketId)}
          {labelText(lang.bookingNo, bookingDetailsData.bookingNumber)}
          {labelText(lang.status, bookingDetailsData.status)}
          {labelText(lang.arrivalDate, formatDate(bookingDetailsData.startTime, DateTime.DDMMYYYY_HHMM))}
          {labelText(lang.departureDate, formatDate(bookingDetailsData.endTime, DateTime.DDMMYYYY_HHMM))}
          {labelText(lang.cancelledAt, formatDate(bookingDetailsData.cancelledAt, DateTime.DDMMYYYY_HHMM) )}
          {labelText(lang.companyDetails, bookingDetailsData.company)}
          {labelText(lang.reasonForStay, bookingDetailsData.reasonForStay)}
        </div>

        {/* 🔹 Guest-level info (matching externalTicketId) */}
        {guestInfo && (
          <>
            <Title sm className="mb-md text-blue-600">
              {lang.guestDetails}
            </Title>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {labelText(
                lang.guestName,
                `${guestInfo.firstName ?? ""} ${guestInfo.lastName ?? ""}`.trim()
              )}
              {labelText(lang.emailAddress, guestInfo.email)}
              {labelText(lang.mobileNumber, guestInfo.mobileNumber)}
              {labelText(lang.nationality, guestInfo.nationality)}
              {labelText(lang.gender, guestInfo.gender)}
              {labelText(lang.preLoadedCredit, matchedGuest?.preLoadedCredit)}
              {/* {labelText(lang.guestProfileId, matchedGuest?.guestProfileId)} */}
            </div>
          </>
        )}

        {!guestInfo && (
          <Text className="text-gray-500 italic mt-2">
            {lang.noGuestFoundForTicket ?? "No guest found for this ticket."}
          </Text>
        )}
      </Panel>
    </div>
  );
};

export default BookingSummary;
